import { render } from "./EmbedText.vue?vue&type=template&id=9a15ebb4&lang=pug"
import script from "./EmbedText.vue?vue&type=script&lang=ts"
export * from "./EmbedText.vue?vue&type=script&lang=ts"
script.render = render

export default script